/**
 * API paths for various CRUD operations
 */
export const apiPaths: { [key: string]: string } = {
  Login: "auth/login",

  getAllEmployees: "auth/users",
  createEmployee: "auth/register",
  updateEmployee: "auth/users/",
  getEmployees: "auth/user",
  getEmployeesWithStatus: "auth/employees-with-status",

  getAllTaskSheets: "tasks",
  updateTaskSheet: "tasks/edit/",
  createTaskSheet: "tasks/create",
  getTasksByUser: "tasks/user/",

  getDailyTasks: "dailyTasks/daily-task/",
  dailyTaskComments: "dailyTasks/daily-task/comments",
  getAllProjects: "projects",
  getProjectById: "projects/",
  createProject: "projects",
  updateProject: "projects/",
  getProjectWithStatus: "projects/projects-with-status",

  getProjects: "projects/name",

  getAllEmpTaskSheets: "tasks/my-tasks",
  getBackLogTaskSheet: "tasks/backLog",
  getPendingTaskSheet: "tasks/pending",
  getUpComingTaskSheet: "tasks/up-coming",
  updateEmpTaskSheet: "tasks/edit/",
  createEmpTaskSheet: "tasks/create",
  taskSummary: "tasks/task-summary",
  adminDashBoard: "tasks/admin-dashboard",

  getEmpDailyTasks: "dailyTasks/user/",
  createEmpDailyTasks: "dailyTasks/daily-task",
  getAdminComment: "dailyTasks/daily-task/comments/admin",
  welcomeAdminCommentAck: "dailyTasks/daily-task/comments/welcome-ack",

  createDocument: "document",
  uploadVideo: "document/upload-video",
  getDocument: "document",
  updateDocument: "document/",
  tags: "document/tags/only",

  getAllClients: "clients",
  getClients: "clients/name/active",
  updateClient: "clients/edit/",
  createClient: "clients/create",
  leadStatus : "leads/lead-status/",
  messages: "leads/:id/messages",
  editMessage:"leads/:id/messages/:messageIndex" ,
  deleteMessage:"leads/:id/messages/:messageIndex",

  getAllLeads: "leads",
  getLeads: "leads/name/active",
  updateLead: "leads/edit/",
  createLead: "leads/create",
  convertLead:"leads/convert/",
  deleteLead: "leads/",
  graphLead:"leads/graph/data",
  myLeads:'leads/assigned/myLead',
  importCsv: "leads/import-csv",

  sendSlackMessage: "slack/message",
  slackConversationsOpen: "slack/conversations/open",
  slackChatPostMessage: "slack/chat/postMessage",
  slackChatPostTodayMessage: "slack/chat/postTodayMessage",
  sendCommentMessage: "slack/chat/sendCommentMessage",

  getLeave: "leave",
  getYears: "leave/years",
  getLeaveUser: "leave/user-leave",
  createLeaveRequest: "leave/",
  updateLeaveRequest: "leave/",
  addYear: "auth/users/add-year",

  outputStatus: "output-statuses",
  outputStatusCreate: "output-statuses/create",
  outputStatusEdit: "output-statuses/edit/",
  outputStatusRemove: "output-statuses/delete/", 

  services: "services",
  servicesCreate: "services/create",
  servicesEdit: "services/edit/",
  servicesRemove: "services/delete/", 

  interests: "interests",
  interestsCreate: "interests/create",
  interestsEdit: "interests/edit/",
  interestsRemove: "interests/delete/", 

  platforms: "platforms",
  platformsCreate: "platforms/create",
  platformsEdit: "platforms/edit/",
  platformsRemove: "platforms/delete/", 

  upload_image: "videos/upload-image",
  upload_video: "videos/upload",
  videos_list: "videos",
  videos_categories: "videos/categories",
  videos_taxonomy: "videos/taxonomy",
  videoCategories: "video-categories",
  videoCategoriesCreate: "video-categories/create",
  videoDelete: "videos/delete/",
  videoEdit: "videos/edit/",

  // Gamification endpoints
  setDailyTarget: "gamification/set-target",
  getAvailableWeeks: "gamification/available-weeks",
  getMyAvailableWeeks: "gamification/my-available-weeks",
  getWeeklyPerformance: "gamification/weekly-performance",
  getMyWeeklyPerformance: "gamification/my-weekly-performance",
  getTodayTarget: "gamification/today-target",


  // Apollo endpoints

  searchEmailerCampaigns: "tools/search-emailer-campaigns",
  addContactToCampaign: "tools/create-contact",
  getEmailerCampaigns: "tools/add-contact-to-campaign",

  // Hiring Employee
  getAllHired: "hiring",
  createHiring: "hiring/create",
  editHiring: "hiring/edit/",
  deleteHiring: "hiring/",
  getHiring:'hiring/',
  hiringStatus:"hiring/hiring-status",
  uploadResume:"hiring/upload-resume",


  // contact leads
  contactCreate:"contacts/create",
  getContact:"contacts",
  singleContact:"contacts/",
  editContact:"contacts/update/",
  deleteContact:"contacts/delete/",
  addNotes:"contacts/:id/notes",
  addMessage:"contacts/:id/messages",
  addFollowup:"contacts/:id/followup",

  // Calendar Tasks
  createCalendarTask: "calendar-tasks/create",
  getCalendarTasks: "calendar-tasks",
  updateCalendarTask: "calendar-tasks/update/",
  deleteCalendarTask: "calendar-tasks/delete/",
  getCalendarTasksByUser: "calendar-tasks/",
  // BDE Form
  bdeFormCreate:"bde-form/create",
  bdeFormEdit:"bde-form/update/",
  bdeFormDelete:"bde-form/delete/",
  bdeFormGet:"bde-form",
  bdeFormGetAll:"bde-form",

  // Campaign
  campaignCreate:"campaign/create",
  campaignEdit:"campaign/",
  campaignGet:"campaign/",
  campaignGetAll:"campaign/count",
  campaignGetList:"campaign",
  campaignImportCsv: "campaign/import-csv",

  // Campaign Data
  campaignDataCreate:"campaigns/create",
  campaignDataGetAll:"campaigns",
  campaignDataEdit:"campaigns/",
  
  // External: Instantly
  instantlyCampaigns: "instantly/campaigns",
  instantlyCampaignsSchedule: "instantly/leads",
  
  // Jibble
  jibbleLink: "jibble/link",
  jibbleStatus: "jibble/status",
  getJibbleStatus: "jibble/status",
  jibbleActivities: "jibble/activities",
  jibbleTimesheet: "jibble/timesheet",
  jibbleDailyEntries: "jibble/time-entries/daily",
  jibbleTimesheetsSummary: "jibble/timesheets-summary",
  jibbleTimesheets: "jibble/timesheets",
  jibbleMembers: "jibble/members",
};
